 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TITLEPAGE01 from '@/components/titlepage01'
 import PREFACE01 from '@/components/preface01'
 import PREFACE02 from '@/components/preface02'
 import CH01 from '@/components/ch01'
 import CH02 from '@/components/ch02'
 import CH03 from '@/components/ch03'
 import CH04 from '@/components/ch04'
 import CH05 from '@/components/ch05'
 import CH06 from '@/components/ch06'
 import CH07 from '@/components/ch07'
 import CH08 from '@/components/ch08'
 import CH09 from '@/components/ch09'
 import CH10 from '@/components/ch10'
 import APP01 from '@/components/app01'
 import PREFACE03 from '@/components/preface03'
 import COLOPHON01 from '@/components/colophon01'
 import COLOPHON02 from '@/components/colophon02'
 import TOC01 from '@/components/toc01'
 import COPYRIGHTPAGE01 from '@/components/copyright-page01'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/titlepage01",
 			"name" : "titlepage01",
 			"component" : TITLEPAGE01
 		},
 		{
 			"path" : "/preface01",
 			"name" : "preface01",
 			"component" : PREFACE01
 		},
 		{
 			"path" : "/preface02",
 			"name" : "preface02",
 			"component" : PREFACE02
 		},
 		{
 			"path" : "/ch01",
 			"name" : "ch01",
 			"component" : CH01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js